import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';
import classNames from 'classnames';
import {
  AVAILABLE,
  UNAVAILABLE,
  ICON_PREFERENCE,
  ICON_CHECK_CIRCLE_OUTLINE,
} from '../../../helpers/constants/common';
import { DEFAULT, SUCCESS } from '../../lib/helpers/componentStates';

const RefundableInfo = ({ refundable, size, className }) => {
  const icon = refundable ? ICON_CHECK_CIRCLE_OUTLINE : ICON_PREFERENCE;
  const color = refundable ? SUCCESS : DEFAULT;
  const availability = refundable ? AVAILABLE : UNAVAILABLE;

  return (
    <div className={classNames('d-flex column-gap-8 align-center', className)}>
      <Icon name={icon} color={color} size={size} />
      {I18n.t(availability, { scope: 'components.ibe.results.filters.refundable' })}
    </div>
  );
};

RefundableInfo.defaultProps = {
  refundable: false,
  size: 'normal',
  className: null,
};

RefundableInfo.propTypes = {
  refundable: PropTypes.bool,
  size: PropTypes.string,
  className: PropTypes.string,
};

export default RefundableInfo;
